import { SurveyType } from '../types';

export const TRACKING_SLACK_ENDPOINTS: Record<SurveyType, string> = {
  [SurveyType.ONBOARDING]:
    'https://hooks.slack.com/triggers/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',
  [SurveyType.UNINSTALL]:
    'https://hooks.slack.com/triggers/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',
  [SurveyType.HEATMAP_BETA]:
    'https://hooks.slack.com/triggers/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',
};
